/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISCaseListSpecimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    lis_state?: LISCaseListSpecimen.lis_state | null;
    site?: string | null;
    /**
     * Changing this value will ALSO modify the collected_date for the case.
     */
    collected_date?: string | null;
}

export namespace LISCaseListSpecimen {

    export enum lis_state {
        BOTTLED = 'bottled',
        RECEIVED = 'received',
        GROSSED = 'grossed',
    }


}
